import { Experience } from '../../types';

export const EXPERIENCES: Experience[] = [
  {
    company: 'Sézane',
    dateStart: '2020/09/01',
    dateEnd: '2026/03/31',
    title: 'Création et refonte des différentes applications web de la marque',
    description: [
      <>
        Équipe front restreinte : <b>référent technique</b> front, en collaboration avec l'équipe back (PHP Symfony)
      </>,
      <>
        Multiples projets avec stacks techniques différentes et problématiques spécifiques :
        <div className="my-4">
          -   <b>Site web retail</b> : Templates Twig modulaires, nombreuses demandes d'évolutions UI
          <br />
          -   <b>Paiement / Compte</b> : Apps modernes, formulaires complexes, services externes (adresses, paiement)
          <br />
          -   <b>Back-office</b> : App historique, nombreux listings / dashboards / formulaires
        </div>
      </>,
      <>
        Mise en place d'une librairie de <b>composants partagés</b> React, de la stack de <b>tests</b> complète
      </>,
      <>
        Conseil pour les choix UX/UI, <b>intégration</b> à partir d'un design system, travail sur l'<b>accessibilité</b>
      </>,
    ],
    tech: ['TypeScript', 'React', 'react-query', 'react-hook-form', 'Tailwind', 'Jest', 'Cypress', 'Vite'],
  },
  {
    company: 'Meetic',
    dateStart: '2019/01/01',
    dateEnd: '2019/11/01',
    isESN: true,
    title: (
      <>
        Projet <b>Affiny</b> — Refonte de l'application web mobile et création des apps Android / iOS
      </>
    ),
    description: [
      <>Équipe initiale composée d'une dizaine de développeurs front expérimentés</>,
      <>
        Mono-repo englobant à la fois le code <b>web et mobile</b> (React-native), forte composante <b>intégration</b> CSS
      </>,
      <>
        Forte attente sur la <b>performance</b> du site, participation aux choix fonctionnels et UI/UX, amélioration continue de la qualité
        technique du projet
      </>,
      <>
        Formation et <b>encadrement</b> de développeurs juniors
      </>,
    ],
    tech: ['TypeScript', 'React', 'React-native', 'Redux', 'Redux-saga', 'Styled-components', 'Jest', 'Webpack', 'Scrum'],
  },
  {
    company: 'Radio France',
    dateStart: '2017/10/01',
    dateEnd: '2018/12/01',
    isESN: true,
    title: 'Refonte des applications de back-office pour les journalistes des sites web Radio France',
    description: [
      <>
        Travail en binôme sur la création de <b>dashboards</b> connectés à une API PHP Symfony
      </>,
      <>Maintenance et correctifs pour les applications existantes</>,
    ],
    tech: ['TypeScript', 'React', 'Redux', 'RxJS', 'Less', 'Jest', 'Webpack'],
  },
  {
    company: 'PMU',
    dateStart: '2017/01/01',
    dateEnd: '2018/10/01',
    isESN: true,
    title: (
      <>
        Projet <b>Hipigo</b> — Création d’une nouvelle application de paris hippiques pour néophytes
      </>
    ),
    description: [
      <>
        Projet pilote <b>agile Scrum</b> : fonctionnement évolutif / itératif (MVP), décisions prises de façon collégiale
      </>,
      <>POCs réalisés en React et VueJS, projet réalisé en BackboneJS (framework historique chez PMU)</>,
      <>
        Attention particulière accordée aux <b>tests</b> (unitaires, intégration et e2e)
      </>,
    ],
    tech: ['BackboneJS', 'Marionette', 'Handlebars', 'Sass', 'Jest', 'WebDriverIO', 'Webpack', 'Scrum'],
  },
  // {
  //   company: 'Challenges — Sciences & Avenir',
  //   dateStart: '2017/01/01',
  //   dateEnd: '2018/10/01',
  //   isESN: true,
  //   title: 'Refonte complète des deux sites media du groupe',
  //   description: [
  //     <>
  //       Création d'un <b>backend NodeJS</b> custom pour construire les pages HTML (connecté à un CRM Drupal)
  //     </>,
  //     <>Intégration CSS spécifique à chaque site (thèmes différents), surcouche jQuery simple</>,
  //     <>
  //       Travail sur les problématiques de <b>performance</b> et de <b>SEO</b> (site media à fort trafic)
  //     </>,
  //   ],
  //   tech: ['NodeJS', 'Express', 'EJS', 'CSS', 'jQuery'],
  // },
];
